export default {
  namespaced: true,

  state: {
    data: {
      region_id: false,
      title: false
    }
  },

  getters: {
    getRegionId: function(state) {
      return state.data.region_id;
    },
    getTitle: function(state) {
      return state.data.title;
    },
  },

  mutations: {
    setRegionId: function(state, region_id) {
      state.data.region_id = region_id;
    },
    setTitle: function(state, title) {
      state.data.title = title;
    }
  },

  actions: {
    setRegionId({commit}, region_id) {
      commit('setRegionId', region_id);
    },
    setTitle({commit}, title) {
      commit('setTitle', title);
    }
  }
};



// WEBPACK FOOTER //
// ./resources/components/store/modules/homepage-map.js